// First-fold VSL + "pillars" copy for the sales home (one entry per interface language).
const pt = {
  kicker: "O Natal está chegando...",
  sub: "Prepare tudo com antecedência e aproveite o que realmente importa.",
  play: "Assista ao vídeo",
  pillarsT1: "O seu Natal pode ser",
  pillarsT2: "mais organizado.",
  pillarsSub: "Planeje sua decoração, sua ceia, seus presentes, suas compras e seu orçamento em um só lugar.",
  cards: ["🎄 Decoração", "🍽️ Ceia", "🎁 Presentes", "🛒 Compras", "💰 Orçamento", "📋 Planejamento"],
};
const ptPT = { ...pt,
  kicker: "O Natal está a chegar...",
  sub: "Prepare tudo com antecedência e aproveite o que realmente importa.",
  play: "Veja o vídeo",
  pillarsSub: "Planeie a sua decoração, a sua consoada, os seus presentes, as suas compras e o seu orçamento num só lugar.",
  cards: ["🎄 Decoração", "🍽️ Consoada", "🎁 Presentes", "🛒 Compras", "💰 Orçamento", "📋 Planeamento"],
};
const en = {
  kicker: "Christmas is coming...",
  sub: "Prepare everything ahead of time and enjoy what really matters.",
  play: "Watch the video",
  pillarsT1: "Your Christmas can be",
  pillarsT2: "more organized.",
  pillarsSub: "Plan your decoration, your dinner, your gifts, your shopping and your budget — all in one place.",
  cards: ["🎄 Decoration", "🍽️ Dinner", "🎁 Gifts", "🛒 Shopping", "💰 Budget", "📋 Planning"],
};
const es = {
  kicker: "La Navidad está llegando...",
  sub: "Prepara todo con antelación y disfruta de lo que realmente importa.",
  play: "Ver el vídeo",
  pillarsT1: "Tu Navidad puede ser",
  pillarsT2: "más organizada.",
  pillarsSub: "Planifica tu decoración, tu cena, tus regalos, tus compras y tu presupuesto en un solo lugar.",
  cards: ["🎄 Decoración", "🍽️ Cena", "🎁 Regalos", "🛒 Compras", "💰 Presupuesto", "📋 Planificación"],
};
const fr = {
  kicker: "Noël approche...",
  sub: "Préparez tout à l'avance et profitez de ce qui compte vraiment.",
  play: "Regarder la vidéo",
  pillarsT1: "Votre Noël peut être",
  pillarsT2: "mieux organisé.",
  pillarsSub: "Planifiez votre décoration, votre repas, vos cadeaux, vos achats et votre budget au même endroit.",
  cards: ["🎄 Décoration", "🍽️ Repas", "🎁 Cadeaux", "🛒 Achats", "💰 Budget", "📋 Planning"],
};
const it = {
  kicker: "Il Natale sta arrivando...",
  sub: "Prepara tutto in anticipo e goditi ciò che conta davvero.",
  play: "Guarda il video",
  pillarsT1: "Il tuo Natale può essere",
  pillarsT2: "più organizzato.",
  pillarsSub: "Pianifica le decorazioni, la cena, i regali, gli acquisti e il budget in un solo posto.",
  cards: ["🎄 Decorazioni", "🍽️ Cena", "🎁 Regali", "🛒 Acquisti", "💰 Budget", "📋 Pianificazione"],
};
const VSL = { pt, "pt-PT": ptPT, en, es, fr, it };
export const vslCopy = (lang) => VSL[lang] || VSL.pt;
export const VSL_SRC = "/media/vsl.mp4";
